import { Form, Button, message } from "antd";
import FormSection from "./FormSection";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { useState } from "react";

const Wrap = styled.div`
  .lite-text {
    color: #636980;
  }
`;

const AppraiserForm = ({
  setStep,
  step,
  appraisarIntroductoryDetail,
  setAppraisarIntroductoryDetail,
  appraisarMainSectionDetail,
  setAppraisarMainSectionDetail,
  appraisarRemarkSectionDetail,
  setAppraisarRemarkSectionDetail,
  setIsAddEditTemplate,
  isAddEditTemplate,
  status,
  setStatus,
  onSubmitClick,
  loading,
  draftLoading,
  scrollToTop,
  mainSectionDetail,
  validateAll,
}) => {
  const [form] = Form.useForm();
  const [mainSectionError, setMainSectionError] = useState(false);

  const validateMainSection = () => {
    const hasAtLeastOneQuestion = appraisarMainSectionDetail?.every(
      (section) => section?.question !== ""
    );

    if (!hasAtLeastOneQuestion) {
      setMainSectionError(true);
      message.error(
        "Main Questionnaire Section is mandatory. Please fill all the questions."
      );
      return false;
    }

    setMainSectionError(false);
    return true;
  };

  const footerStyle = {
    position: "sticky",
    bottom: -20,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  return (
    <Wrap>
      <h6 className="mb-3">Appraiser's Form</h6>
      <h6>Indroductory Section</h6>
      <p className="lite-text">
        This section is used to collect basic details of appraisee and set
        context for the appraisal. This may include information like employee
        name, role, brief note etc...
      </p>
      <section className="form_builder main_container">
        <Row className="d-flex justify-content-center">
          <Col md={10} lg={7} sm={12}>
            <FormSection
              setFullFormDetail={setAppraisarIntroductoryDetail}
              fullFormDetail={appraisarIntroductoryDetail}
              appraisarform={true}
            />
          </Col>
        </Row>
      </section>

      <h6 className="mt-5">
        Main Questionnaire Section<span className="text-danger">*</span>
      </h6>
      <p className="lite-text">
        This is the core performance evaluation section. Employees rate
        themselves and answer questions related to skills, goals, and
        performance. These questions will be automatically duplicated in the
        Appraiser form so that both self-ratings and reviewer ratings can be
        compared.
      </p>
      {mainSectionError && (
        <div
          style={{
            color: "red",
            fontSize: "13px",
            marginBottom: "8px",
            marginTop: "-4px",
          }}
        >
          Please fill all the questions in this section.
        </div>
      )}
      <section
        className="form_builder main_container"
        style={{
          border: mainSectionError ? "1px solid red" : "none",
          borderRadius: mainSectionError ? "8px" : "0",
          padding: mainSectionError ? "8px" : "0",
        }}
      >
        <Row className="d-flex justify-content-center">
          <Col md={10} lg={7} sm={12}>
            <FormSection
              setFullFormDetail={(val) => {
                setAppraisarMainSectionDetail(val);
                if (
                  Array.isArray(val) &&
                  val?.every((section) => section?.question !== "")
                ) {
                  setMainSectionError(false);
                }
              }}
              fullFormDetail={appraisarMainSectionDetail}
              appraisarform={true}
              linkedFormDetail={mainSectionDetail} // ✅ pass appraisee main section
            />
          </Col>
        </Row>
      </section>

      <h6 className="mt-5">Remarks & Feedback Section</h6>
      <p className="lite-text">
        This section allows the employee to share additional comments,
        challenges, achievements, or expectations. It supports open feedback
        beyond ratings.
      </p>
      <section className="form_builder main_container">
        <Row className="d-flex justify-content-center">
          <Col md={10} lg={7} sm={12}>
            <FormSection
              setFullFormDetail={setAppraisarRemarkSectionDetail}
              fullFormDetail={appraisarRemarkSectionDetail}
              appraisarform={true}
            />
          </Col>
        </Row>
      </section>

      {status !== "view" && (
        <div style={footerStyle}>
          <ButtonOutlined
            className="border-0"
            onClick={() => {
              setStatus("");
              setIsAddEditTemplate(false);
            }}
          >
            Cancel
          </ButtonOutlined>
          {status !== "edit" && (
            <>
              <ButtonOutlined
                loading={draftLoading}
                onClick={() => onSubmitClick("draft")}
              >
                Save as Draft
              </ButtonOutlined>
              <ButtonOutlined
                onClick={() => {
                  scrollToTop();
                  setStep(step - 1);
                }}
              >
                Previous
              </ButtonOutlined>
            </>
          )}
          <ButtonFilled
            loading={loading}
            type="primary"
            htmlType="submit"
            onClick={() => {
              if (!validateMainSection()) return;

              if (
                appraisarMainSectionDetail?.every(
                  (section) => section?.question !== ""
                ) &&
                status !== "edit"
              ) {
                scrollToTop();
                setStep(step + 1);
              } else if (
                appraisarMainSectionDetail?.every(
                  (section) => section?.question !== ""
                ) &&
                status === "edit"
              ) {
                if (!validateAll()) return;
                onSubmitClick("");
              }
            }}
          >
            {status === "edit" ? "Update" : "Next"}
          </ButtonFilled>
        </div>
      )}
    </Wrap>
  );
};

export default AppraiserForm;
